import{css as e}from"lit-element";export const pulse=e`@keyframes pulse{from{opacity:.85}to{opacity:.45}}`;
//# sourceMappingURL=animations.js.map